/**
 * Funcões uteis para recuperar e definir informações do pedido
 */

/**
 * Retorna o link Vindi resolvido pelo backend, quando disponível.
 *
 * @param {object} order
 * @returns {string}
 */
export function getRecurrencePaymentUrl(order) {
  const paymentLink = order?.urls?.change_payment;
  return paymentLink?.url || "";
}

/**
 * Monta url da troca de pagamento.
 * @param {object} order
 * @param {object} storeInfo
 * @returns {string}
 */
export function getEditOrderUrl(order, storeInfo) {
  const recurrencePaymentUrl = getRecurrencePaymentUrl(order);

  if (recurrencePaymentUrl) {
    return recurrencePaymentUrl;
  }

  const storeUrl = storeInfo.uri.https;
  const storeId = storeInfo.id;
  const accessCode = order.access_code;

  const url = `${storeUrl}/checkout/recover?loja=${storeId}&pedido=${accessCode}&pag=1`;

  return url;
}
